module.exports = __webpack_public_path__ + "img/blank.8cfcbbf9.jpg";